import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { catchError, map, Observable, of, throwError } from 'rxjs';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';

import { AlertApi } from './models';
import { AppConstants } from '../../app.constants';
import { Alert } from '../domain/models';

@Injectable({
    providedIn: 'root'
})
export class AlertMiscApiService extends BaseMiscApiService
{
    constructor (protected http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlAuth;
        this.segmentApi = '/auth/alerts';
    }

    getAlerts (): Observable<AlertApi[]>
    {
        return this.get<AlertApi[]>('');
    }

    getActiveAlerts (): Observable<AlertApi[]>
    {
        return this.get<AlertApi[]>('/active');
    }

    createAlert (alert: Alert): Observable<AlertApi>
    {
        return this.post<AlertApi>('', alert);
    }

    updateAlert(alert: Alert): Observable<AlertApi>
    {
        return this.patch<AlertApi>('', alert);
    }

    disableAlert (alertId: string): Observable<void>
    {
        return this.patch(`/disable/${alertId}`, {});
    }

    activateAlert (alertId: string): Observable<void>
    {
        return this.patch(`/activate/${alertId}`, {});
    }

    deleteAlert (alertId: string): Observable<void>
    {
        return this.delete(`/delete/${alertId}`, {});
    }
}
